(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sportshub-localization"] && !Shopify.designMode) return;
  try {
    if (!window.sportshubLocalizationReady) {
    window.sportshubLocalizationReady = true;

    document.addEventListener('click', (event) => {
      document.querySelectorAll('details.sh-locale[open], details.sh-locale__menu[open]').forEach((element) => {
        if (!element.contains(event.target)) element.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('details.sh-locale[open], details.sh-locale__menu[open]').forEach((element) => {
        element.removeAttribute('open');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
